/**************************************************
 * Nombre:       Seccion_Detalle_Coleccion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Lista_Productos from "./Componentes/Lista_Productos";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useParams} from "react-router";
import {useEffect, useState} from "react";
import {collection, orderBy, query, where} from "firebase/firestore";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {irArriba} from "../../Utilidades/irArriba";
import {fire} from "../../fire";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";
import Detalle_Coleccion_Portada from "./Componentes/Detalle_Coleccion_Portada";
import Home_Suscripcion from "./Componentes/Home_Suscripcion";
import DetalleCol_Compra_Look from "./Componentes/DetalleCol_Compra_Look";

const Seccion_Detalle_Coleccion = () => {
    const {sCell} = useResponsive()
    const parms = useParams()
    const [coleccion, setColeccion] = useState({})
    const [productos, setProductos] = useState([])
    const [id, setId] = useState()

    useEffect(() => {

        if (parms && parms.id && id !== parms.id) {

            irArriba()
            setId(parms.id)
            setProductos([])

            obtenerDoc('colecciones', parms.id).then((dox) => {
                if (dox.res) {
                    setColeccion(dox.data)
                }
            })


            let q = query(collection(fire, 'productos'), where('idColeccion', '==', parms.id), where('estado', '==', 'Publicado'), orderBy('tipo', 'asc'))

            obtenerColeccionQuery(q).then((dox) => {
                if (dox.res) {
                    setProductos(dox.data)
                }
            })


        }

    }, [parms])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Detalle_Coleccion_Portada item={coleccion}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 4 : 8}}>
                <Lista_Productos productos={productos}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 8 : 16, mb: sCell ? 8 : 16}}>
                <DetalleCol_Compra_Look items={productos}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 8 : 0, mb: sCell ? 8 : 14}}>
                <Home_Suscripcion/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Detalle_Coleccion